// Shared styled-components for the legal pages (Privacy Policy, Cookie Policy).
// Mirrors the existing boxy / hard-drop-shadow aesthetic of the site, on the
// global JetBrains Mono font. Centered with a readable max-width on desktop.
import styled from "styled-components";
import { Link } from "react-router-dom";

export const LegalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 48px 16px 96px;
  background-color: #f8f9fa;

  @media (max-width: 600px) {
    padding: 24px 12px 72px;
  }
`;

export const LegalInner = styled.div`
  width: 100%;
  max-width: 820px;
`;

export const HeaderTitle = styled.h1`
  text-align: center;
  margin: 0 0 6px;
  font-size: 28px;

  @media (max-width: 600px) {
    font-size: 22px;
  }
`;

export const Subtle = styled.p`
  color: #6b7280;
  font-size: 13px;
  text-align: center;
  margin: 0 0 8px;
`;

export const BoxDiv = styled.section`
  border: 1px solid #111;
  padding: 22px 24px;
  box-shadow: 5px 10px rgba(0, 0, 0, 0.7);
  margin: 22px 0;
  background-color: #ffffff;
  line-height: 1.6;

  p {
    margin: 10px 0;
  }
  ul {
    margin: 8px 0 8px 18px;
    padding: 0;
  }
  li {
    margin: 5px 0;
  }
  a {
    color: #b800a8;
    text-decoration: underline;
  }
  strong {
    font-weight: 600;
  }

  @media (max-width: 600px) {
    padding: 16px 16px;
  }
`;

export const SectionTitle = styled.h2`
  margin: 24px 0 8px;
  font-size: 18px;
  border-bottom: 2px solid #111;
  padding-bottom: 4px;

  &:first-child {
    margin-top: 0;
  }
`;

export const SubTitle = styled.h3`
  margin: 16px 0 4px;
  font-size: 15px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 14px 0;
  font-size: 13px;

  th,
  td {
    border: 1px solid #d1d5db;
    padding: 8px 10px;
    text-align: left;
    vertical-align: top;
  }
  th {
    background: #f3f4f6;
    font-weight: 600;
  }

  @media (max-width: 600px) {
    font-size: 11.5px;
    th,
    td {
      padding: 6px 7px;
    }
  }
`;

export const CrossLinks = styled.div`
  display: flex;
  gap: 18px;
  justify-content: center;
  flex-wrap: wrap;
  margin: 4px 0 8px;
  font-size: 13px;
`;

export const PageLink = styled(Link)`
  color: #b800a8;
  text-decoration: underline;
`;
